
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";

import { ErrorMessage } from "@hookform/error-message";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Input,
  Modal,
  ModalBody
} from "reactstrap";
import { GET, POST, PUT } from "../../helper/api";
import { CUSTOMER_LOCATION, DEFAULT_CUSTOMER, DEFAULT_CUSTOMER_BANK_ACCOUNT, formatLicensePlate, getCustomerLocationOptions } from '../../utils/Utils';
import banks from '../../utils/banks';
import RTag from "../../components/tags/ReactTag";
const BANK_OPTIONS = banks.map((c) => ({
  label: `${c.code} - ${c.shortName} - ${c.name}`,
  value: c.code,
  data: c,
}));

const UpsertCustomer = ({ type, setLoading, onSuccess, onFormCancel, isOpen, editId }) => {

  const normalLabel = type === 'OUT' ? "khách hàng" : "nhà cung cấp";
  const locationOptions = getCustomerLocationOptions(type);
  const { errors, register, handleSubmit, reset, getValues, watch, control, setValue, formState: { isDirty } } = useForm(
    {
      defaultValues: {
        ...DEFAULT_CUSTOMER,
      },
    }
  );

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'metadata.bankAccounts',
    defaultValue: [
      {
        ...DEFAULT_CUSTOMER_BANK_ACCOUNT,
      }
    ]
  });


  const findInfoByTaxCode = async () => {
    const taxCode = getValues('metadata.taxCode');
    if (!taxCode) {
      return;
    }
    const { data: {
      data,
      message
    } } = await GET(`/common/find-info-by-tax-code/${taxCode}`, {}, true);
    if (!data) {
      toast.error(message || 'Không tìm thấy thông tin');
      return;
    }
    setValue('metadata.taxCompanyName', data.name);
    setValue('metadata.taxAddress', data.address);
    setValue('metadata.address', data.address);
  }

  useEffect(() => {
    if (!editId) {
      return;
    }
    setLoading(true);
    GET(`/customer/${editId}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
          location: data.location || CUSTOMER_LOCATION.INTERNAL,
          licensePlates: data.licensePlates || [],
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [editId]);

  const isDeliveryProvider = watch('isDeliveryProvider');
  const onHandleSubmit = () => {
    setLoading(true);
    const {
      name,
      id,
      isDeliveryProvider,
      licensePlates,
      metadata,
      location,
    } = getValues();

    const formData = {
      id,
      name,
      type,
      location: location || CUSTOMER_LOCATION.INTERNAL,
      isDeliveryProvider,
      licensePlates: isDeliveryProvider ? (licensePlates || []) : [],
      metadata,
    };
    const request = editId ? PUT(`/customer/${editId}`, formData, {}, true) : POST(`/customer`, formData, {}, true)

    request.then((res) => {
      toast.success(editId ? "Sửa thành công" : "Thêm thành công");
      onSuccess(res.data)
    })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onCancel = () => {
    reset({ ...DEFAULT_CUSTOMER });
    onFormCancel()
  }

  return <Modal
    isOpen={isOpen}
    toggle={onCancel}
    className="modal-dialog-centered"
    size="xl"
  >
    <ModalBody>
      <a href="#cancel" className="close">
        {" "}
        <Icon
          name="cross-sm"
          onClick={(ev) => {
            ev.preventDefault();
            onCancel();
          }}
        ></Icon>
      </a>
      <div className="p-2">
        <h5 className="title">{editId ? 'Sửa' : 'Thêm'} {normalLabel}</h5>
        <div className="mt-4">
          <form onSubmit={handleSubmit(onHandleSubmit)} className="g-3">
            <Row className="g-3">
              <Col md="4">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Mã {normalLabel}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      className="form-control"
                      name="id"
                      ref={register({
                        required: "Vui lòng nhập thông tin",
                      })}
                      disabled={!!editId}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="id"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>

              <Col md="4">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Tên {normalLabel}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      ref={register({
                        required: "Vui lòng nhập thông tin",
                      })}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="name"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col md="4">
                <div className="form-group">
                  <label className="form-label" htmlFor="location">
                    Location
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="location"
                      render={({ onChange, value, name, ref }) => (
                        <RSelect
                          inputRef={ref}
                          name={name}
                          options={locationOptions}
                          value={locationOptions.find((c) => c.value === (value || CUSTOMER_LOCATION.INTERNAL))}
                          onChange={(val) => onChange(val.value)}
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col md="4">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Đây là nhà vận chuyển
                  </label>
                  <div className="form-control-wrap d-flex  align-items-start gap-2">
                    <div>
                      <input
                        type="checkbox"
                        name="isDeliveryProvider"
                        className="ml-0"
                        ref={register({

                        })}
                      />
                    </div>
                    <div className="ml-3">{isDeliveryProvider ? 'Có' : 'Không'}</div>
                  </div>
                </div>
              </Col>
              {isDeliveryProvider && (
                <Col md="12">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Biển số xe
                    </label>
                    <div className="form-control-wrap">
                      <Controller
                        control={control}
                        name="licensePlates"
                        render={({ onChange, value }) => {
                          const tags = (value || []).map((e) => ({ id: e, text: e }));
                          return (
                            <RTag
                              tags={tags}
                              handleDelete={(i) => onChange((value || []).filter((_, idx) => idx !== i))}
                              handleAddition={(tag) => {
                                const plate = formatLicensePlate(tag.text);
                                if (!plate || (value || []).includes(plate)) return;
                                onChange([...(value || []), plate]);
                              }}
                              delimiters={[188, 186, 13]}
                              placeholder="Nhập biển số rồi Enter hoặc dấu phẩy"
                              allowUnique
                            />
                          );
                        }}
                      />
                    </div>
                  </div>
                </Col>
              )}

            </Row>
            <hr />
            <Row>
              <Col md="4">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Mã số thuế
                  </label>
                  <div className="form-control-wrap">
                    <Controller control={control} name="metadata.taxCode" render={(field) => (
                      <div className="d-flex">
                        <input
                          type="text"
                          className="form-control"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e.target.value.replace(/[^0-9\-]/g, ''));
                          }}
                        />
                        <Button className={`btn btn-secondary`}
                          onClick={findInfoByTaxCode}
                          type="button"
                        >
                          <Icon name="search"></Icon>
                        </Button>
                      </div>

                    )} />
                    <ErrorMessage
                      errors={errors}
                      name="metadata.taxCode"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col md="4">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Tên công ty
                  </label>
                  <div className="form-control-wrap">
                    <Controller control={control} name="metadata.taxCompanyName" render={(field) => (
                      <input
                        type="text"
                        className="form-control"
                        {...field}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                      />
                    )} />
                    <ErrorMessage
                      errors={errors}
                      name="metadata.taxCompanyName"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col md="4">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Số điện thoại
                  </label>
                  <div className="form-control-wrap">
                    <Controller control={control} name="metadata.phoneNumber" render={(field) => (
                      <input
                        type="text"
                        className="form-control"
                        {...field}
                        onChange={(e) => {
                          field.onChange(e.target.value.replace(/[^0-9]/g, ''));
                        }}
                      />
                    )} />
                    <ErrorMessage
                      errors={errors}
                      name="metadata.phoneNumber"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col md="12">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Địa chỉ thuế công ty
                  </label>
                  <div className="form-control-wrap">
                    <Controller control={control} name="metadata.taxAddress" render={(field) => (
                      <input
                        type="text"
                        className="form-control"
                        {...field}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                      />
                    )} />
                    <ErrorMessage
                      errors={errors}
                      name="metadata.taxAddress"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col md="12">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Email xuất VAT
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="metadata.vatEmail"
                      render={({ onChange, value }) => {
                        const tags = value
                          ? value.split(',').map((e) => e.trim()).filter(Boolean).map((e) => ({ id: e, text: e }))
                          : [];
                        return (
                          <RTag
                            tags={tags}
                            handleDelete={(i) => onChange(tags.filter((_, idx) => idx !== i).map((t) => t.text).join(','))}
                            handleAddition={(tag) => onChange([...tags, tag].map((t) => t.text).join(','))}
                            delimiters={[188, 186, 13]}
                            placeholder="Nhập email rồi Enter hoặc dấu phẩy"
                            allowUnique
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col md="12">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Địa chỉ công ty
                  </label>
                  <div className="form-control-wrap">
                    <Controller control={control} name="metadata.address" render={(field) => (
                      <input
                        type="text"
                        className="form-control"
                        {...field}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                      />
                    )} />
                    <ErrorMessage
                      errors={errors}
                      name="metadata.address"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col md="12">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Ghi chú
                  </label>
                  <div className="form-control-wrap">
                    <Controller control={control} name="metadata.note" render={(field) => (
                      <textarea
                        className="form-control"
                        style={{ minHeight: "50px" }}
                        {...field}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                      />
                    )} />
                    <ErrorMessage
                      errors={errors}
                      name="metadata.note"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col size="12">
                <h5 className="w-100 d-flex align-items-center justify-content-between">
                  <span>Tài khoản ngân hàng</span>
                  <Button color="primary" type="button" onClick={() => append({ ...DEFAULT_CUSTOMER_BANK_ACCOUNT })}>
                    Thêm TK NH
                  </Button>
                </h5>
              </Col>
              <Col size="12" className={`pt-2`}>
                {fields.map((field, index) => (
                  <Row className="g-3" key={field.id}>
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Ngân hàng
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name={`metadata.bankAccounts.${index}.bankCode`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={BANK_OPTIONS}
                                value={BANK_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name={`metadata.bankAccounts.${index}.bankCode`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Số tài khoản <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name={`metadata.bankAccounts.${index}.bankNumber`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <Input
                                inputRef={ref}
                                name={name}
                                onChange={(e) => onChange(e.target.value)}
                                value={value}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name={`metadata.bankAccounts.${index}.bankNumber`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tên chủ tài khoản <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name={`metadata.bankAccounts.${index}.name`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <Input
                                inputRef={ref}
                                name={name}
                                onChange={(e) => onChange(e.target.value)}
                                value={value}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name={`metadata.bankAccounts.${index}.name`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Chi nhánh
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name={`metadata.bankAccounts.${index}.branch`}
                            render={({ onChange, value, name, ref }) => (
                              <Input
                                inputRef={ref}
                                name={name}
                                onChange={(e) => onChange(e.target.value)}
                                value={value}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="danger" type="button" onClick={() => remove(index)}>
                        <Icon name="trash"></Icon>
                        <span>Xóa</span>
                      </Button>
                      <hr />
                    </Col>
                  </Row>
                ))}
              </Col>
            </Row>
            <Row>
              <Col size="12">
                <Button color="primary" type="submit">
                  <Icon className="plus"></Icon>
                  <span>{editId ? 'Sửa' : 'Thêm'} {normalLabel}</span>
                </Button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </ModalBody>
  </Modal>

}

export default UpsertCustomer